import "core-js/modules/es.array.push.js";
import appHead from "./home_head.vue";
import showproduct from "./home_show.vue";
import productindex from "./home_product.vue";
import blankBottom from "@/components/base/blankBottom.vue";
import { getLocalImagePath } from "@/lang/getLocalImg.js";
import selectMode from "./select_button.vue";
import appWidget from "@/components/widget/index.vue";
import test_modal from "@/components/tools/test_modal.vue";

//额外附加的数据(后台计算需要这些数据，前端并没使用)
const attachData = {
  scalewidth: 50,
  scaleheight: 50,
  width_chunk: 10,
  height_chunk: 10,
  imgcropbox: {
    left: 0,
    top: 0,
    width: 100,
    height: 100
  }
};
export default {
  name: "Upload",
  components: {
    appHead,
    showproduct,
    productindex,
    blankBottom,
    selectMode,
    appWidget
  },
  data() {
    return {
      // uploading: false,
      // showDetails: false,
      // uploadUrl: "/sunbiliang/doubleface_upload", //上传图片的接口
      // createButImg: require("@/assets/doubleFaced/createBut.png"), //创建生成按钮
      imageTransButImg: getLocalImagePath('home_imagetrans_button'),
      //开始拼装按钮
      premodelsButtonImg: getLocalImagePath('home_premodels_button'),
      //预置模型按钮
      selectboxImg: require('@/assets/painting/first_button_bk.jpg'),
      //选择框背景图片

      // imageTransBackgroud : require('@/assets/fusebeads/first_picture_bk.jpg'),
      // premodelsBackgroud : require('@/assets/fusebeads/first_premodel_bk.jpg'),
      logotitle: require('@/assets/amalia-title.png'),
      // particelImg: require("@/assets/doubleFaced/particle.png"), //颗粒图
      // shopUrl: "https://www.amazon.com/dp/B0CDLJRPNT", //商店地址
      shopUrl: "https://www.amazon.co.uk/gp/product/B09JVKX8NZ?th=1"
    };
  },
  mounted() {
    // const imageTrans = document.querySelector('.image_trans');
    // const parentElement = imageTrans.parentNode;
  },
  methods: {
    //点击使用指南
    handleGuide() {
      this.$router.push({
        path: 'guide'
      });
    },
    //点击图片转换页面
    gotoImageTrans() {
      this.$router.push({
        path: "imagetransfer"
      });
      //保存拼装记录
      // if (localStorage) {
      //   this.buildRecordData = localStorage.setItem("buildRecordData",modelUrl);
      // }
    },

    gotoPreModels() {
      // this.$router.push({ path: "premodels" });
      // 测试弹窗
      // this.$router.push({ path: "test_modal" });
      this.$router.push({
        path: "test_camera"
      });
    }
  }
};